
import Vue from "vue"

export default Vue.extend({
  props: {
    breadcrumbs: {
      type: Object as VuePropType<Record<string, string>>,
      required: true,
    },
  },

  computed: {
    getTitle () {
      return (token: string) => this.$te(token)
        ? this.$t(token)
        : token
    },
  },
})
